/* eslint-disable max-len */
import { t } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { Avatar } from 'antd';
import { ConditionalTooltip } from 'bukku/components/Tooltip/ConditionalTooltip';
import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';

export function UserAvatarWithTooltip({hasPopoverMenu}) {
    useLingui();
    const user = useSelector(state => state.Auth.user, shallowEqual);
    const {
        is_landlord: isLandlord,
    } = user;

    const getAvatarBorderColor = () => {
        switch (isLandlord) {
            case 1:
                return 'blue';
            case 2:
                return 'green';
            default:
                return '';
        }
    };

    const getAvatarTootlip = () => {
        switch (isLandlord) {
            case 1:
                return t`The landlord’s access to the company is overridden with read-only access for all modules.`;
            case 2:
                return t`The landlord’s access to the company is overridden with full access for all modules.`;
            default:
                return null;
        }
    };

    return (
        <ConditionalTooltip
            rules={[
                {
                    condition: (isLandlord === 1 || isLandlord === 2) && !hasPopoverMenu,
                    message: getAvatarTootlip(),
                },
            ]}
            popupContainerId="avatar-round-border"
            placement="bottomRight"
        >
            <div>
                <div
                    id="avatar-round-border"
                    className={`avatar-round-border ${getAvatarBorderColor()}`}
                />
                <Avatar
                    size="large"
                    style={{
                        backgroundColor: '#00a2ae',
                        boxSizing: 'content-box',
                    }}
                >
                    {user?.first_name?.substr(0, 4) || 'User'}
                </Avatar>
            </div>
        </ConditionalTooltip>
    );
}
